export default (element) => {
  const initShareButtons = () => {
    element.querySelectorAll('[data-share="facebook"]').forEach(el => {
      el.setAttribute('target', '_blank');
      // eslint-disable-next-line max-len,no-param-reassign
      el.href = `https://www.facebook.com/sharer/sharer.php?u=${window.location.href}`;
    });
  }

  const init = () => {
    initShareButtons();
  };

  init();
};
